module.exports = __webpack_public_path__ + "img/set-disciplinary.a9aff6a2.png";